import { getAndroidId, getIosIdForVendorAsync } from "expo-application";
import { DeviceType as ExpoDeviceType } from "expo-device";
import { Platform } from "react-native";
import uuid from "react-native-uuid";

import { captureException } from "@/services/AppMonitor";
import { isAndroid, isIOS } from "@/utils/platform.util";

enum DeviceTypeValue {
  Desktop = "Desktop",
  Phone = "Phone",
  Tablet = "Tablet",
  Tv = "Tv",
  Unknown = "Unknown",
}

const getDeviceTypeValue = (type: ExpoDeviceType | null): DeviceTypeValue => {
  // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
  switch (type) {
    case ExpoDeviceType.DESKTOP:
      return DeviceTypeValue.Desktop;
    case ExpoDeviceType.PHONE:
      return DeviceTypeValue.Phone;
    case ExpoDeviceType.TABLET:
      return DeviceTypeValue.Tablet;
    case ExpoDeviceType.TV:
      return DeviceTypeValue.Tv;
    default:
      return DeviceTypeValue.Unknown;
  }
};

const getFallbackDeviceId = (): string => {
  return `fallback-${Platform.OS}-${uuid.v4().toString()}`;
};

const getDeviceUniqueId = async (): Promise<string> => {
  if (isIOS()) {
    try {
      const iosId = await getIosIdForVendorAsync();
      return iosId || getFallbackDeviceId();
    } catch (error) {
      captureException(error);
      return getFallbackDeviceId();
    }
  }
  if (isAndroid()) {
    return getAndroidId();
  }
  return getFallbackDeviceId();
};

export { DeviceTypeValue, getDeviceTypeValue, getDeviceUniqueId };
